import { updateField } from './updateField';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
export const updatePreselectedOptions = (selectedOptions, value, fieldType) => {
  if (fieldType === FieldTypes.RADIO || fieldType === FieldTypes.SELECT || fieldType === FieldTypes.PAYMENT_RADIO) {
    return [value];
  }
  if (selectedOptions.includes(value)) {
    return selectedOptions.filter(option => option !== value);
  }
  return [...selectedOptions, value];
};
export const addPreselectedOption = ({
  formField,
  value,
  handleUpdate = () => {}
}) => {
  const updatedSelectedOptions = updatePreselectedOptions(formField.selectedOptions, value, formField.fieldType);
  handleUpdate(updateField(formField, 'selectedOptions', updatedSelectedOptions));
};